export default "__VITE_ASSET__DlDGHPXs__"